import {registerClientCredentialsExecutor} from '@zoefin/request';

import {executeClientCredentialsCall} from '.';

// Imported for its side effect by the root providers, so the action is part of
// every route's module graph. A production build only serves an action that a
// route's own graph imports; registering from instrumentation-client.ts left it
// out, and every call answered 404 "Server action not found".
registerClientCredentialsExecutor(executeClientCredentialsCall);
